import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Card, Row, Col, Badge, Button, Spinner, Table } from "react-bootstrap";
import {
  editHost,
  editHostSubscription,
  getSUBSCRIPTION,
  getUserCohosts,
  getUserDetail,
  getUserEvent,
  getUserGuests,
  getHostWeddings,
} from "../../services/UserServices/UserService";
import Pagination from "../components/Pagination";
import { Modal, Form } from "react-bootstrap";
import PageContentLoader from "../components/TableLoader";
import { Formik } from "formik";
import { useParams } from "react-router-dom";
import PageTitle from "../layouts/PageTitle";
import "react-phone-input-2/lib/style.css";
import toast from "react-hot-toast";
import { EVENT_NAME } from "../../utils/events";
import * as Yup from "yup";
import { ArrowLeft, Edit3, CreditCard, ChevronRight, Heart } from "lucide-react";

const UserDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const HostDetailsSchema = Yup.object().shape({
    userId: Yup.string().required(),

    hostName: Yup.string()
      .trim()
      .matches(
        /^[A-Za-z ]+$/,
        "Host name can only contain letters and spaces"
      )
      .min(2, "Host name must be at least 2 characters")
      .required("Host name is required"),

    brideName: Yup.string()
      .trim()
      .matches(
        /^[A-Za-z ]+$/,
        "Bride name can only contain letters and spaces"
      )
      .min(2, "Bride name must be at least 2 characters")
      .required("Bride name is required"),

    groomName: Yup.string()
      .trim()
      .matches(
        /^[A-Za-z ]+$/,
        "Groom name can only contain letters and spaces"
      )
      .min(2, "Groom name must be at least 2 characters")
      .required("Groom name is required"),

    phoneNumber: Yup.string()
      .matches(/^[0-9]+$/, "Phone number must contain only digits")
      .min(7, "Phone number is too short")
      .max(15, "Phone number is too long")
      .required("Phone number is required"),
    hostSide: Yup.string().required("Host side code is required"),
    countryCode: Yup.string().required("Country code is required"),
    countryCode: Yup.string().required("Country code is required"),
  });
  const [user, setUser] = useState();
  const [userEvent, setUserEvent] = useState([]);
  const [userCoHosts, setUserCoHosts] = useState([]);
  const [userGuests, setUserGuests] = useState([]);
  const [count, setCount] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const { id } = useParams();
  const [showPlanModal, setShowPlanModal] = useState(false)
  const [plans, setPlans] = useState([])
  const [device, setDevice] = useState()
  const [guestCount, setGuestCount] = useState(null)
  const [stats, setStats] = useState(null)
  const [loading, setLoading] = useState(true);

  const [hostWeddings, setHostWeddings] = useState([]);
  const [weddingPage, setWeddingPage] = useState(0);
  const [weddingCount, setWeddingCount] = useState(0);
  const [weddingLoading, setWeddingLoading] = useState(false);
  const getData = async () => {

    try {
      setLoading(true);
      const res = await getUserDetail(id);

      setUser(res?.data?.data?.user);

      setStats(res?.data?.data)
      setDevice(res?.data?.data?.tokens)
    } catch (error) {
      console.error(error?.response?.data?.message);
    }
    finally {
      setLoading(false);
    }
  };
  useEffect(() => {

    if (id) {
      getData();
    }
  }, [id]);




  useEffect(() => {
    const getCohosts = async () => {

      try {
        setLoading(true);
        const res = await getUserCohosts(id);

        setUserCoHosts(res?.data?.data?.coHosts);
      } catch (error) {
        console.error(error?.response?.data?.message);
      }
      finally {
        setLoading(false);
      }
    };
    if (id) {
      getCohosts();
    }

    const fetchSubscription = async () => {
      try {
        const res = await getSUBSCRIPTION();
        setPlans(res?.data?.data);
      } catch (error) {
        console.error("Error fetching subscriptions:", error);
      }
    };


    fetchSubscription()

  }, [id]);









  useEffect(() => {
    const getGuests = async () => {

      try {
        setLoading(true);
        const res = await getUserGuests(id);

        setUserGuests(res?.data?.data?.guests);
        setGuestCount(res?.data?.data?.count)
      } catch (error) {
        console.error(error?.response?.data?.message);
      }
      finally {
        setLoading(false);
      }
    };
    if (id) {
      getGuests();
    }
  }, [id]);

  useEffect(() => {
    const fetchWeddings = async () => {
      if (!id || !user?.firstLogin) return;
      try {
        setWeddingLoading(true);
        const res = await getHostWeddings(id, weddingPage, 5);
        const list = res?.data?.data?.weddings || res?.data?.weddings || [];
        const total =
          res?.data?.data?.count ??
          res?.data?.data?.total ??
          res?.data?.count ??
          res?.data?.total ??
          res?.data?.data?.totalWeddings ??
          (Array.isArray(list) ? list.length : 0);
        setHostWeddings(Array.isArray(list) ? list : []);
        setWeddingCount(total);
      } catch (error) {
        console.error("Error fetching host weddings:", error);
      } finally {
        setWeddingLoading(false);
      }
    };
    if (user?.firstLogin) {
      fetchWeddings();
    }
  }, [id, user?.firstLogin, weddingPage]);

 
  useEffect(() => {
    const getEvent = async () => {
      try {
        const res = await getUserEvent(id);

        const mappedEvents = res?.data?.data?.events
          ?.map((response) => {
            const eventId = response?.name?.id;

            // ✅ MATCH BY ID
            const matchEvent = EVENT_NAME.find((event) => event.id === eventId);

            if (!matchEvent) {
              return {
                id: eventId || "custom",
                name: response?.name?.name || "Custom Event",
                eventId: response._id,
                venue: response?.eventVenue,
                date: response?.eventDate,
                subEvents: response?.subEvents || [],
                selectedTheme: response?.theme,
                selectedDressCode: response?.dressCode,
                selectedDressColor: response?.dressColor,
                isGalleryExists: response?.isGalleryExists,
                theme: [],
                dressCode: [],
                dressColor: [],
              };
            }

            const resolveValue = (staticList, responseItem) => {
              if (!responseItem) return null;

              // ✅ If custom → explicitly return the user's custom name
              if (responseItem.id === "custom") {
                return {
                  id: "custom",
                  name: responseItem.name || "Custom" // Ensure the custom text isn't lost
                };
              }

              // ✅ Otherwise map from static config
              return (
                staticList?.find((s) => s.id === responseItem.id) || responseItem
              );
            };

            return {
              ...matchEvent,
              // ✅ OVERRIDE the static 'Custom' name with the actual response name
              name: response?.name?.name || matchEvent.name,

              eventId: response._id,
              venue: response?.eventVenue,
              date: response?.eventDate,
              subEvents: response?.subEvents || [],
              selectedTheme: resolveValue(matchEvent.theme, response.theme),
              selectedDressCode: resolveValue(matchEvent.dressCode, response.dressCode),
              selectedDressColor: resolveValue(matchEvent.dressColor, response.dressColor),
              isGalleryExists: response?.isGalleryExists,
            };
          })
          .filter(Boolean);

        setUserEvent(mappedEvents);
        setCount(res?.data?.data?.count);
      } catch (error) {
        console.error(error?.response?.data?.message);
      }
    };

    if (id) {
      getEvent();
    }
  }, [id]);



  const displayedEvents = userEvent.slice(0, 3);



  const handleUpdate = async (values) => {
    try {

      await editHost(values)
      getData();
      toast.success("User info updated")
      setShowModal(false);
    } catch (error) {
      console.error(error)

    }
  }


  if (loading) {
    return (
      <div className="qx-page">
        <PageContentLoader message="Loading user details..." />
      </div>
    );
  }
  return (
    <div className="qx-page qx-detail-page">
      <PageTitle
        pageTitle={user?.hostName || "User Details"}
        subtitle="View host profile, events, co-hosts, and guest information"
        breadcrumbs={[
          {
            label: "User List",
            path: "/user-management",
          },
          {
            label: user?.hostName || "User",
          },
        ]}
        actions={
          <div className="d-flex flex-wrap gap-2">
            <Button
              variant="outline-secondary"
              className="d-inline-flex align-items-center gap-2"
              onClick={() => navigate(-1)}
            >
              <ArrowLeft size={16} />
              Back
            </Button>
            {/* <Button
              className="btn-primary qx-btn-brand d-inline-flex align-items-center gap-2"
              onClick={() => setShowPlanModal(true)}
            >
              <CreditCard size={16} />
              Change Plan
            </Button> */}
            <Button
              className="btn-primary qx-btn-brand d-inline-flex align-items-center gap-2"
              onClick={() => setShowModal(true)}
            >
              <Edit3 size={16} />
              Edit Details
            </Button>
          </div>
        }
      />

  <Card className="premium-card qx-section-card mb-4 overflow-hidden">
        <Card.Body className="p-3 p-md-4">
          <div className="d-flex flex-column flex-md-row align-items-md-center gap-3 gap-md-4">
            <img
              className="qx-user-profile-img flex-shrink-0"
              src={
                user?.couplePhoto
                  ? `https://managemyshaadib.s3.ap-south-1.amazonaws.com/${user.couplePhoto}`
                  : "https://img.freepik.com/premium-vector/vector-flat-illustration-grayscale-avatar-user-profile-person-icon-profile-picture-business-profile-woman-suitable-social-media-profiles-icons-screensavers-as-templatex9_719432-1339.jpg"
              }
              alt="Profile"
            />
            <div className="flex-grow-1">
              <h4 className="fw-bold mb-1 text-dark">{user?.hostName || "—"}</h4>
              <p className="text-muted mb-2">
                {user?.countryCode} {user?.phoneNumber}
              </p>
              <div className="d-flex flex-wrap gap-2">
                {user?.plan?.name && (
                  <Badge
                    className="px-3 py-2 fw-semibold"
                    style={{ borderRadius: "0.5rem", background: "#800001" }}
                  >
                    {user.plan.name}
                  </Badge>
                )}
                {user?.hostSide && (
                  <Badge bg="light" text="dark" className="px-3 py-2 fw-medium border">
                    Host Side: {user.hostSide.charAt(0).toUpperCase()}{user.hostSide.slice(1)}
                  </Badge>
                )}
              </div>
            </div>
          </div>
        </Card.Body>
      </Card>
 
      {(user?.groomName || user?.brideName) && (
        <Card className="premium-card qx-section-card mb-4 border-0 shadow-sm" style={{ borderRadius: "1rem" }}>
          <Card.Body
            className="p-3 px-md-4 py-md-3 d-flex align-items-center justify-content-between flex-wrap gap-2"
            style={{
              background: "linear-gradient(135deg, #FFF8EC 0%, #FFEECB 100%)",
              border: "1.5px solid #F6D68F",
              borderRadius: "1rem",
            }}
          >
            <div className="d-flex align-items-center gap-3">
              <div
                className="rounded-circle d-flex align-items-center justify-content-center shadow-sm"
                style={{
                  width: "42px",
                  height: "42px",
                  backgroundColor: "#FFE5E5",
                  border: "1px solid #FFC1C1",
                }}
              >
                <Heart size={22} className="text-danger" fill="#dc3545" />
              </div>
              <div>
                <div
                  className="small fw-semibold text-uppercase"
                  style={{ letterSpacing: "0.5px", fontSize: "0.725rem", color: "#9A3412" }}
                >
                  Wedding Name
                </div>
                <span className="fw-bold fs-4" style={{ color: "#800001", letterSpacing: "-0.2px" }}>
                  {user?.groomName || "—"} & {user?.brideName || "—"}
                </span>
              </div>
            </div>
 
          </Card.Body>
        </Card>
      )}

      {/* User Events */}
      {displayedEvents && displayedEvents.length > 0 && (
        <Card className="premium-card qx-section-card mb-4">
          <Card.Body className="p-0">
            <div className="d-flex align-items-center justify-content-between px-3 px-md-4 pt-3 pb-2">
              <div>
                <h6 className="qx-section-card__title text-uppercase small mb-1">Events</h6>
                {count ? <span className="text-muted small">Total: {count}</span> : null}
              </div>
              <span
                className="qx-section-card__link"
                onClick={() =>
                  navigate(`/user_events/${id}`, {
                    state: { history: { user } },
                  })
                }
              >
                See all →
              </span>
            </div>
            <div style={{ maxHeight: "420px", overflowY: "auto" }}>
              {displayedEvents.map((event) => (
                <div key={event?.eventId} className="qx-event-item">
                  <h5 className="fw-bold mb-3">{event?.name}</h5>
                  <div className="qx-host-info-grid qx-host-info-grid--event">
                    <div className="qx-detail-field">
                      <span className="qx-detail-field__label">Event Date/Time</span>
                      <span className="qx-detail-field__value">
                        {event?.date
                          ? new Date(event.date).toLocaleString("en-IN", {
                              year: "numeric",
                              month: "short",
                              day: "numeric",
                              hour: "2-digit",
                              minute: "2-digit",
                              hour12: true,
                            })
                          : "—"}
                      </span>
                    </div>
                    <div className="qx-detail-field">
                      <span className="qx-detail-field__label">Venue</span>
                      <span className="qx-detail-field__value">{event?.venue || "N/A"}</span>
                    </div>
                    <div className="qx-detail-field">
                      <span className="qx-detail-field__label">Theme</span>
                      <span className="qx-detail-field__value">
                        {event?.selectedTheme?.name || "N/A"}
                      </span>
                    </div>
                    <div className="qx-detail-field">
                      <span className="qx-detail-field__label">Dress Code</span>
                      <span className="qx-detail-field__value">
                        {event?.selectedDressCode?.name || "N/A"}
                      </span>
                    </div>
                    <div className="qx-detail-field">
                      <span className="qx-detail-field__label">Dress Color</span>
                      <span className="qx-detail-field__value">
                        {event?.selectedDressColor?.name || "N/A"}
                      </span>
                    </div>
                  </div>
                  <div className="qx-event-actions">
                    {event?.subEvents?.length > 0 && (
                      <Button
                        size="sm"
                        className="qx-btn-brand"
                        onClick={() =>
                          navigate(`/sub-events/${id}/${event?.eventId}`, {
                            state: { history: { event, user } },
                          })
                        }
                      >
                        Sub Events
                      </Button>
                    )}
                    <Button
                      size="sm"
                      className="qx-btn-brand"
                      onClick={() =>
                        navigate(`/guests/${id}/${event?.eventId}`, {
                          state: { history: { event, user } },
                        })
                      }
                    >
                      Guests
                    </Button>
                    <Button
                      size="sm"
                      className="qx-btn-brand"
                      onClick={() =>
                        navigate(`/tasks/${id}/${event?.eventId}`, {
                          state: { history: { event, user } },
                        })
                      }
                    >
                      Tasks
                    </Button>
                    {event?.isGalleryExists && (
                      <Button
                        size="sm"
                        className="qx-btn-brand"
                        onClick={() =>
                          navigate(`/user-photo-gallery/${event.eventId}`, {
                            state: { history: { event, user } },
                          })
                        }
                      >
                        Photos
                      </Button>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </Card.Body>
        </Card>
      )}




      {/* -------- Co-Hosts Card -------- */}

      {userCoHosts && userCoHosts.length > 0 && (
        <Card className="premium-card qx-section-card mb-4">
          <Card.Body className="p-0">
            <div className="d-flex align-items-center justify-content-between px-3 px-md-4 pt-3 pb-2">
              <h6 className="qx-section-card__title text-uppercase small mb-0">Co-Hosts</h6>
              <span
                className="qx-section-card__link"
                onClick={() =>
                  navigate(`/user-details/${id}/co-hosts-list`, {
                    state: { history: { user } },
                  })
                }
              >
                See all →
              </span>
            </div>
            <div style={{ maxHeight: "300px", overflowY: "auto" }}>
              {userCoHosts.map((host) => (
                <div key={host._id} className="qx-list-item">
                  <div>
                    <div className="qx-list-item__title">{host.coHostName}</div>
                    <p className="qx-list-item__meta">
                      {host.countryCode} {host.phoneNumber}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </Card.Body>
        </Card>
      )}


      {userGuests && userGuests.length > 0 && (
        <Card className="premium-card qx-section-card mb-4">
          <Card.Body className="p-0">
            <div className="d-flex align-items-center justify-content-between px-3 px-md-4 pt-3 pb-2">
              <div>
                <h6 className="qx-section-card__title text-uppercase small mb-1">Guests</h6>
                {guestCount ? (
                  <span className="text-muted small">Invite links shared: {guestCount}</span>
                ) : null}
              </div>
              <span
                className="qx-section-card__link"
                onClick={() =>
                  navigate(`/user-details/${id}/guest-list`, {
                    state: { history: { user } },
                  })
                }
              >
                See all →
              </span>
            </div>
            <div style={{ maxHeight: "300px", overflowY: "auto" }}>
              {userGuests.slice(0, 2).map((guest) => (
                <div key={guest.id} className="qx-list-item">
                  <div>
                    <div className="qx-list-item__title">{guest.name}</div>
                    <p className="qx-list-item__meta">
                      {guest?.countryCode} {guest?.phoneNumber}
                    </p>
                    {guest.invites ? (
                      <p className="qx-list-item__meta mb-0">{guest.invites}</p>
                    ) : null}
                  </div>
                </div>
              ))}
            </div>
          </Card.Body>
        </Card>
      )}

      {user?.firstLogin && (weddingLoading || (hostWeddings && hostWeddings.length > 0)) && (
        <Card className="premium-card qx-section-card mb-4">
          <div className="p-3 p-md-4" style={{ padding: "1.5rem" }}>
            <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-3 pb-2 border-bottom">
              <div>
                <h6 className="qx-section-card__title text-uppercase small mb-1">
                  More Weddings
                </h6>
                <span className="text-muted small">
                  Total Weddings: {weddingCount}
                </span>
              </div>
            </div>

            {weddingLoading ? (
              <div className="text-center py-4">
                <Spinner animation="border" variant="primary" size="sm" />
              </div>
            ) : (
              <>
                <Table responsive className="mb-0 align-middle">
                  <thead>
                    <tr>
                      <th className="py-3 px-3">#</th>
                      <th className="py-3 px-3">Groom & Bride Name</th>
                      <th className="py-3 px-3">Host Name</th>
                      <th className="py-3 px-3">Phone Number</th>
                      <th className="py-3 px-3">Plan</th>
                      <th className="py-3 px-3">Date</th>
                      <th className="py-3 px-3"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {hostWeddings.map((wedding, idx) => (
                      <tr key={wedding._id || idx}>
                        <td className="py-3.5 px-3 fw-semibold text-muted">
                          {weddingPage * 5 + idx + 1}
                        </td>
                        <td className="py-3.5 px-3">
                          <span className="fw-bold">
                            {wedding.groomName || "—"} & {wedding.brideName || "—"}
                          </span>
                        </td>
                        <td className="py-3.5 px-3">
                          <span className="fw-semibold">
                            {wedding.hostName || "—"}
                          </span>
                        </td>
                        <td className="py-3.5 px-3">
                          {wedding.phoneNumber || "—"}
                        </td>
                        <td className="py-3.5 px-3">
                          <Badge bg="info" className="rounded-pill px-3 py-1 fw-medium">
                            {wedding.plan?.name || wedding.plan?.id?.name || "—"}
                          </Badge>
                        </td>
                        <td className="py-3.5 px-3 text-secondary">
                          {wedding.createdAt
                            ? new Date(wedding.createdAt).toLocaleString("en-IN", {
                                year: "numeric",
                                month: "short",
                                day: "numeric",
                                hour: "2-digit",
                                minute: "2-digit",
                                hour12: true,
                              })
                            : "—"}
                        </td>
                        <td>
                          <button
                            type="button"
                            className="qx-action-view"
                            title="View event"
                            aria-label="View event"
                            onClick={() =>
                              navigate(`/host-wedding/${wedding?._id}`)
                            }
                          >
                            <ChevronRight size={18} strokeWidth={2.5} />
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
                <div className="mt-3">
                  <Pagination
                    pageValue={weddingPage}
                    setPage={(page) => setWeddingPage(page)}
                    total={weddingCount}
                    pageSize={5}
                    pageCount={Math.ceil(weddingCount / 5)}
                  />
                </div>
              </>
            )}
          </div>
        </Card>
      )}

        {user?.planHistory?.length > 0 && (
        <Card className="premium-card qx-section-card mb-4">
          <div className="p-3 p-md-4" style={{ padding: "1.5rem" }}>
            <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-3 pb-2 border-bottom">
              <div>
                <h6 className="qx-section-card__title text-uppercase small mb-1">
            Plan Upgrade History ⭐
                </h6>
 
              </div>
            </div>
            <Table responsive className="mb-0 align-middle">
              <thead>
                <tr>
                  <th className="py-3 px-3">#</th>
                  <th className="py-3 px-3">Plan Name</th>
                  <th className="py-3 px-3">Price</th>
                  <th className="py-3 px-3">Date & Time</th>
       
                </tr>
              </thead>
              <tbody>
                {[...user.planHistory]
                  .sort((a, b) => new Date(b.createdAt || 0) - new Date(a.createdAt || 0))
                  .map((historyItem, idx) => (
                    <tr key={historyItem._id || idx}>
                      <td className="py-3.5 px-3 fw-semibold text-muted">{idx + 1}</td>
                      <td className="py-3.5 px-3">
                        <span className="fw-bold text-dark">
                          {historyItem?.name || historyItem?.subscriptionId?.name || "—"}
                        </span>
                      </td>
                      <td className="py-3.5 px-3">
                        <span className="fw-semibold" style={{ color: "#334155" }}>
                          {historyItem?.price ? `₹${Number(historyItem.price).toLocaleString("en-IN")}` : "—"}
                        </span>
                      </td>
                      <td className="py-3.5 px-3 text-secondary">
                        {historyItem?.createdAt
                          ? new Date(historyItem.createdAt).toLocaleString("en-IN", {
                              year: "numeric",
                              month: "short",
                              day: "numeric",
                              hour: "2-digit",
                              minute: "2-digit",
                              hour12: true,
                            })
                          : "—"}
                      </td>
                      
                    </tr>
                  ))}
              </tbody>
            </Table>
          </div>
        </Card>
      )}
  
      {device?.length > 0 ? (
        <Card className="premium-card qx-section-card mb-4">
          <div className="p-3 p-md-4" style={{ padding: "1.5rem" }}>
            <div className="d-flex flex-wrap align-items-center gap-2 mb-3">
              <h6 className="qx-section-card__title text-uppercase small mb-0">
                Device Login Info
              </h6>
              <Badge bg="light" text="dark" className="border fw-medium">
                Total devices: {device?.length}
              </Badge>
            </div>
            <Table responsive className="mb-0">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Device Type</th>
                  <th>Device ID</th>
                  <th>Last Login</th>
                </tr>
              </thead>
              <tbody>
                {device?.[0] && (
                  <tr>
                    <td>1</td>
                    <td>{device[0]?.device?.type || "—"}</td>
                    <td>{device[0]?.device?.id || "—"}</td>
                    <td>
                      {device[0]?.createdAt
                        ? new Date(device[0].createdAt).toLocaleString("en-IN", {
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      })
                        : "—"}
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </Card>
      ) : null}





      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
        backdrop="static"
        className="qx-modal"
        dialogClassName="qx-modal-dialog"
        container={typeof document !== "undefined" ? document.body : undefined}
      >
        <Modal.Header closeButton>
          <Modal.Title>Edit User Details</Modal.Title>
        </Modal.Header>

        <Formik
          initialValues={{
            userId: user?._id,
            hostName: user?.hostName,
            brideName: user?.brideName || "",
            groomName: user?.groomName || "",
            hostSide: user?.hostSide || "",
            phoneNumber: user?.phoneNumber || "",
            countryCode: user?.countryCode || "+91",
          }}
          validationSchema={HostDetailsSchema}
          onSubmit={handleUpdate}
        >
          {({
            handleSubmit,
            handleChange,
            values,
            touched,
            errors,
            setFieldValue,
          }) => (
            <>
              <Modal.Body>
                <Form>


                  <Form.Group className="mb-3">
                    <Form.Label>Host Name*</Form.Label>
                    <Form.Control
                      name="hostName"
                      placeholder="Enter host's name (e.g. Aman)"
                      value={values.hostName}
                      onChange={handleChange}
                      isInvalid={touched.hostName && !!errors.hostName}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.hostName}
                    </Form.Control.Feedback>
                  </Form.Group>
                  {/* Bride Name */}
                  <Form.Group className="mb-3">
                    <Form.Label>Bride Name*</Form.Label>
                    <Form.Control
                      name="brideName"
                      placeholder="Enter bride's name (e.g. Neha)"
                      value={values.brideName}
                      onChange={handleChange}
                      isInvalid={touched.brideName && !!errors.brideName}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.brideName}
                    </Form.Control.Feedback>
                  </Form.Group>

                  {/* Groom Name */}
                  <Form.Group className="mb-3">
                    <Form.Label>Groom Name*</Form.Label>
                    <Form.Control
                      name="groomName"
                      value={values.groomName}
                      placeholder="Enter groom's name (e.g. Rahul)"
                      onChange={handleChange}
                      isInvalid={touched.groomName && !!errors.groomName}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.groomName}
                    </Form.Control.Feedback>
                  </Form.Group>

                  {/* Host Side */}
                  <Form.Group className="mb-3">
                    <Form.Label>Host Side</Form.Label>
                    <Form.Select
                      name="hostSide"
                      value={values.hostSide}
                      onChange={handleChange}
                    >
                      <option value=" ">select host side</option>
                      <option value="bride">Bride</option>
                      <option value="groom">Groom</option>
                    </Form.Select>

                    <Form.Control.Feedback type="invalid">
                      {errors.hostSide}
                    </Form.Control.Feedback>

                  </Form.Group>

                 
                  {/* Phone Number */}
                  <Form.Group className="mb-3">
                    <Form.Label>Phone Number*</Form.Label>
                    <div className="input-group">
                      <span className="input-group-text fw-bold" style={{ backgroundColor: "#f8fafc", color: "#475569" }}>
                        {values.countryCode || "+91"}
                      </span>
                      <Form.Control
                        name="phoneNumber"
                        placeholder="Enter phone number"
                        value={values.phoneNumber}
                        onChange={handleChange}
                        isInvalid={touched.phoneNumber && !!errors.phoneNumber}
                      />
                    </div>
                    {touched.phoneNumber && errors.phoneNumber && (
                      <div className="invalid-feedback d-block">
                        {errors.phoneNumber}
                      </div>
                    )}
                  </Form.Group>




                </Form>
              </Modal.Body>

              <Modal.Footer>
                <Button variant="outline-secondary" onClick={() => setShowModal(false)}>
                  Cancel
                </Button>
                <Button className="btn-primary qx-btn-brand" onClick={handleSubmit}>
                  Save Changes
                </Button>
              </Modal.Footer>
            </>
          )}
        </Formik>
      </Modal>


      <Modal
        show={showPlanModal}
        onHide={() => setShowPlanModal(false)}
        centered
        backdrop="static"
        className="qx-modal"
        dialogClassName="qx-modal-dialog"
        container={typeof document !== "undefined" ? document.body : undefined}
      >
        <Modal.Header closeButton>
          <Modal.Title>Change Plan</Modal.Title>
        </Modal.Header>

        <Formik
          initialValues={{ planId: user?.plan?.id || "", userId: user?._id }}

          onSubmit={async (values) => {
            try {
              console.log("user", user)
              const payload = {
                userId: values.userId,
                subscriptionId: values.planId
              }
              await editHostSubscription(payload)
              toast.success("plan updated")
              getData()
              setShowPlanModal(false);
            } catch (error) {
              console.error(error)
            }
          }}
        >
          {({ handleSubmit, values, handleChange, errors, touched }) => (
            <Form onSubmit={handleSubmit}>
              <Modal.Body>
                <Form.Group className="mb-3">
                  <Form.Label>Select New Plan</Form.Label>

                  <Form.Select
                    name="planId"
                    value={values.planId}
                    onChange={handleChange}
                    isInvalid={touched.planId && !!errors.planId}
                  >


                    {plans.map((plan) => (
                      <option key={plan._id} value={plan._id}>
                        {plan?.name}
                      </option>
                    ))}
                  </Form.Select>

                  <Form.Control.Feedback type="invalid">
                    {errors.planId}
                  </Form.Control.Feedback>
                </Form.Group>
              </Modal.Body>

              <Modal.Footer>
                <Button variant="outline-secondary" onClick={() => setShowPlanModal(false)}>
                  Cancel
                </Button>
                <Button type="submit" className="btn-primary qx-btn-brand">
                  Save Changes
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>




    </div>
  );
};

export default UserDetails;
